import React from "react"
import gifImage from "../../assets/images/gif-images/gif-rectangle.svg"
import Wave from "../Wave/Wave"
import "./FeaturedBlog.scss"

const FeaturedBlog = ({ data, sm }) => {
  const { name, abstract, image } = data

  return (
    <div className={`blog-container ${sm ? "blog-articles" : ""}`}>
      <h1 className="card-title">{name}</h1>
      <div className="blog-teaser">{abstract}</div>

      {sm ? (
        <div className="featured-blog-images-container">
          <Wave />
          <img
            src={gifImage}
            alt="gif"
            width="72"
            height="180"
            className="gif-img"
          />
          <img
            src={`${image[0].staticImages.blog_lg[1].src}`}
            alt={image.alternativeText}
            width="854"
            height="533"
            className="blog-big-img"
          />
        </div>
      ) : (
        <div className="featured-blog__image-container">
          <picture>
            <source
              media="(max-width: 575px)"
              srcSet={`${image[0].staticImages.blog_sm[1].src}`}
            />
            <source
              media="(min-width: 576px) and (max-width: 991px)"
              srcSet={`${image[0].staticImages.blog_lg[1].src}`}
            />
            <source
              media="(min-width: 992px)"
              srcSet={`${image[0].staticImages.blog[1].src}`}
            />
            <img
              src={`${image[0].staticImages.blog[1].src}`}
              alt={image.alternativeText}
            />
          </picture>
        </div>
      )}
    </div>
  )
}

export default FeaturedBlog
